import { visitorList, visitorDetails } from "constants/visitor";

const initialState = {
  visitorList: {},
  visitorDetails: {},
};

const visitors = (state = initialState, action) => {
  switch (action.type) {
    case visitorList:
      return { ...state, visitorList: action.payload };

    case visitorDetails:
      return { ...state, visitorDetails: action.payload };

    default:
      return state;
  }
};

export default visitors;
